import { render, staticRenderFns } from "./ContentItemInformationTable.vue?vue&type=template&id=197dec06&"
import script from "./ContentItemInformationTable.vue?vue&type=script&lang=ts&"
export * from "./ContentItemInformationTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContentItemInformationTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection});
